import React, {useEffect, useState} from 'react'
import { TableWrapper } from '../../../libs/react-mpk/wrapper'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './BatasUpahHarian.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'
import Utils from '../../../libs/custom/Utils'

var _baseId = "mod-table-batas-upah-harian"

const BatasUpahHarianTable = ({
  className       = '',
  showCommandbar  = true,
  history
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
    TableWrapper.reload(_baseId)
  }

  return (
    <>
    <TableWrapper
      baseId={_baseId}
      title={t.translate('modules.batasUpahHarian.title')}
      className={className}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="createdDate"
      columns={[
        {
          label: 'Mulai Berlaku (Tahun)',
          searchable: true,
          key: 'dari',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.dari)
        },{
          label: 'Sampai Berlaku (Tahun)',
          searchable: true,
          key: 'ke',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.ke)
        },{
          label: 'Lapis 1 (Rp)',
          searchable: true,
          key: 'lapis1',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.lapis1))
        },{
          label: 'Lapis 2 (Rp)',
          searchable: true,
          key: 'lapis2',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.lapis2))
        },{
          label: 'Lapis 3 (Rp)',
          searchable: true,
          key: 'lapis3',
          type: TableWrapper.dataTypes.STRING,
          render: item => (Utils.numberFormat(item.lapis3))
        }
      ]}
      actions={[
        new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push('/onpremise/batas-upah-harian/baru'), true)
      ]}
      itemActions={[
        new TableWrapper.action('Edit', 'mdi mdi-pencil', (item) => history.push(`/onpremise/batas-upah-harian/${item.id}`), true),
        new TableWrapper.action('Delete', 'mdi mdi-delete', (item) => { setConfirmDeleteData(item); setConfirmDelete(true)}, true)
      ]}
      onFetchData={ async query => {
        return service.get(query)
      }}
      showCommandbar={showCommandbar}
      showFilterPeriod={false}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    </>
  )
}

export default BatasUpahHarianTable
